import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useMutation } from '@grandvisionhq/graphql';
import { DateUtils } from '@grandvisionhq/utils';
import { errorsMapping } from '../../../constants/errors.js';
import '../../../operations/mutations/cancel-anonymous-subscription.js';
import { CANCEL_SUBSCRIPTION } from '../../../operations/mutations/cancel-subscription.js';

const useCancelSubscription = ({ onError , onCompleted  } = {})=>{
    const handleOnCompleted = React.useCallback((responseData)=>{
        if (responseData.cancelSubscription) {
            var ref;
            const result = responseData.cancelSubscription;
            if (result.success) {
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted('MUTATION');
                toast.success('account.subscriptionCancel.success');
            }
            if ((ref = result.failures) === null || ref === void 0 ? void 0 : ref.length) {
                result.failures.forEach((failure)=>{
                    switch(failure === null || failure === void 0 ? void 0 : failure.__typename){
                        case 'SubscriptionNotFoundFailure':
                            console.error('Failed to cancel subscription due to invalid subscription id');
                            toast.failed(errorsMapping.SUBSCRIPTION_NOT_FOUND);
                            break;
                        case 'UnauthorizedFailure':
                            console.error('Invalid account credentials for cancelling subscription');
                            toast.failed(errorsMapping.SUBSCRIPTION_UNAUTHORIZED);
                            break;
                        case 'InvalidTerminationDateFailure':
                            console.error('Invalid termination date provided');
                            toast.failed(errorsMapping.SUBSCRIPTION_INVALID_TERMINATION_DATE);
                            break;
                    }
                });
            }
        }
    }, [
        onCompleted
    ]);
    const handleOnError = React.useCallback((e)=>{
        console.error(e);
        onError === null || onError === void 0 ? void 0 : onError({
            reason: 'MUTATION'
        });
        // General error for apollo error response
        toast.failed(errorsMapping.SOMETHING_WENT_WRONG);
    }, [
        onError
    ]);
    const [cancel, { loading: isUpdating , error  }] = useMutation(CANCEL_SUBSCRIPTION, {
        onCompleted: handleOnCompleted,
        onError: handleOnError,
        refetchQueries: [
            'GetMySubscriptionDetails'
        ],
        awaitRefetchQueries: true
    });
    const cancelSubscription = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(subscriptionId, cancelDate, cancelReason) {
            yield cancel({
                variables: {
                    subscriptionId,
                    cancelDate: DateUtils.toLocalDate(cancelDate),
                    cancelReason
                },
                context: {
                    timeout: 30000
                }
            });
        });
        return function(subscriptionId, cancelDate, cancelReason) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cancel
    ]);
    return {
        isUpdating,
        error,
        cancelSubscription
    };
};

export { useCancelSubscription };
//# sourceMappingURL=use-cancel-subscription.js.map
